import React from 'react';
import SportsEsportsRoundedIcon from '@mui/icons-material/SportsEsportsRounded';
import { WordQuestNavButton } from './style';

const WordQuestNavEntry = ({ active = false, onClick }) => (
  <WordQuestNavButton
    type="button"
    $active={active}
    aria-current={active ? 'page' : undefined}
    aria-label="Word Quest"
    onClick={onClick}
  >
    <SportsEsportsRoundedIcon sx={{ fontSize: 18 }} aria-hidden="true" />
    <span>Word Quest</span>
  </WordQuestNavButton>
);

export default WordQuestNavEntry;
